module.exports = __webpack_public_path__ + "img/明十三陵.eab33944.png";